
import "./ToggleSwitchCore.st.css.js";

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_ToggleSwitchCoreColor";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_ToggleSwitchCoreColor__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"colorUnchecked":"#999","colorChecked":"#999","colorUncheckedHover":"#999","colorCheckedHover":"#999","colorDisabled":"#999"}; 
export var vars = {"wds-color-fill-standard-tertiary":"--wds-color-fill-standard-tertiary"}; 




